export function h(componentOrTag, attr) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (componentOrTag.render != null) {
        return componentOrTag;
    }
    var result = {
        tag: componentOrTag,
        attr: attr
    };
    if (children.length > 0) {
        if (children.length === 1 && typeof children[0] === "string") {
            result.content = children[0];
        }
        else {
            result.children = [];
            for (var _a = 0, children_1 = children; _a < children_1.length; _a++) {
                var child = children_1[_a];
                if (Array.isArray(child)) {
                    child.map(function (c) { return result.children.push(c); });
                }
                else if (child != null && child.tag === undefined && child.render === undefined) {
                    // TODO: this is not what React does -> needs to change in future version
                    result.children.push({ tag: "span", content: child.toString() });
                }
                else {
                    result.children.push(child);
                }
            }
        }
    }
    if (result.attr && result.attr.animation) {
        result.animation = result.attr.animation;
    }
    return result;
}
export var React = {
    createElement: h
};
window.React = React;
